import { render, staticRenderFns } from "./p29.vue?vue&type=template&id=52338ec2&scoped=true&"
import script from "./p29.vue?vue&type=script&lang=js&"
export * from "./p29.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52338ec2",
  null
  
)

export default component.exports